import { render, staticRenderFns } from "./entityDialogView.vue?vue&type=template&id=1c2d5622&scoped=true&"
import script from "./entityDialogView.vue?vue&type=script&lang=js&"
export * from "./entityDialogView.vue?vue&type=script&lang=js&"
import style0 from "./entityDialogView.vue?vue&type=style&index=0&id=1c2d5622&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2d5622",
  null
  
)

export default component.exports